import React, { useState } from 'react';

const AdminLogin = ({ onLogin, onBack }) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (onLogin) onLogin();
    };

    return (
        <div className="flex min-h-screen font-sans antialiased bg-[#F8FAFC]">
            {/* Left Side: Illustration and Info */}
            <div className="hidden lg:flex lg:w-1/2 bg-[#131C2E] relative overflow-hidden flex-col items-center justify-center p-12">
                <div
                    className="absolute inset-0"
                    style={{
                        backgroundImage: 'radial-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px)',
                        backgroundSize: '32px 32px'
                    }}
                ></div>
                <div className="relative z-10 flex flex-col items-center text-center max-w-md">
                    <div className="w-20 h-20 bg-[#00A669] rounded-2xl flex items-center justify-center text-white font-bold text-4xl shadow-lg mb-8">
                        H
                    </div>
                    <h1 className="text-4xl font-bold text-white mb-4 tracking-tight">Admin Control Center</h1>
                    <p className="text-slate-400 text-lg leading-relaxed">
                        Access the centralized management suite for course creation, student analytics, and platform administration.
                    </p>
                </div>
                <div className="absolute bottom-[-10%] left-[-10%] w-64 h-64 bg-[#00A669]/10 rounded-full blur-3xl"></div>
                <div className="absolute top-[-10%] right-[-10%] w-96 h-96 bg-[#00A669]/5 rounded-full blur-3xl"></div>
            </div>

            {/* Right Side: Login Form */}
            <div className="w-full lg:w-1/2 flex items-center justify-center p-6 sm:p-12 bg-white">
                <div className="w-full max-w-md">
                    <div className="lg:hidden mb-12 flex justify-center">
                        <div className="w-12 h-12 bg-[#00A669] rounded-xl flex items-center justify-center text-white font-bold text-2xl">
                            H
                        </div>
                    </div>
                    <div className="mb-8 md:mb-10 text-center lg:text-left">
                        <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-2">Welcome Back</h2>
                        <p className="text-sm md:text-base text-slate-500">Please enter your credentials to access the master dashboard.</p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block text-sm font-semibold text-slate-700 mb-2" htmlFor="username">
                                Admin Email / Username
                            </label>
                            <div className="relative">
                                <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
                                    person
                                </span>
                                <input
                                    className="w-full pl-12 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-[#00A669] focus:border-[#00A669] transition-all text-slate-900 text-sm md:text-base"
                                    id="username"
                                    name="username"
                                    placeholder="admin@himigoplatform.com"
                                    required
                                    type="text"
                                />
                            </div>
                        </div>

                        <div>
                            <div className="flex items-center justify-between mb-2">
                                <label className="block text-sm font-semibold text-slate-700" htmlFor="password">
                                    Password
                                </label>
                                <a className="text-sm font-semibold text-[#00A669] hover:text-emerald-700 transition-colors" href="#">
                                    Forgot Password?
                                </a>
                            </div>
                            <div className="relative">
                                <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
                                    lock
                                </span>
                                <input
                                    className="w-full pl-12 pr-12 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-[#00A669] focus:border-[#00A669] transition-all text-slate-900 text-sm md:text-base"
                                    id="password"
                                    name="password"
                                    placeholder="••••••••"
                                    required
                                    type={showPassword ? "text" : "password"}
                                />
                                <button
                                    className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors"
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    <span className="material-symbols-outlined">
                                        {showPassword ? 'visibility_off' : 'visibility'}
                                    </span>
                                </button>
                            </div>
                        </div>

                        <div className="flex items-center">
                            <input
                                className="h-4 w-4 text-[#00A669] focus:ring-[#00A669] border-slate-300 rounded"
                                id="remember-me"
                                name="remember-me"
                                type="checkbox"
                            />
                            <label className="ml-3 block text-sm text-slate-600 font-medium" htmlFor="remember-me">
                                Remember this device
                            </label>
                        </div>

                        <button
                            className="w-full bg-[#00A669] hover:bg-emerald-700 text-white font-bold py-3.5 md:py-4 px-6 rounded-xl shadow-md shadow-emerald-200 transition-all transform hover:scale-[1.01] active:scale-[0.99] flex items-center justify-center gap-2 text-sm md:text-base"
                            type="submit"
                        >
                            <span>Login to Dashboard</span>
                            <span className="material-symbols-outlined">arrow_forward</span>
                        </button>
                    </form>

                    <div className="mt-8 md:mt-12 text-center">
                        <button
                            onClick={onBack}
                            className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-[#00A669] transition-colors group"
                        >
                            <span className="material-symbols-outlined text-sm transition-transform group-hover:-translate-x-1">
                                arrow_back
                            </span>
                            Return to Main Website
                        </button>
                    </div>

                    <div className="mt-12 md:mt-16 pt-8 border-t border-slate-100 flex flex-col md:flex-row justify-between items-center gap-4 text-[11px] font-bold text-slate-400 uppercase tracking-widest">
                        <span>© 2024 Himigo Platform</span>
                        <div className="flex gap-4">
                            <a className="hover:text-slate-600" href="#">Security</a>
                            <a className="hover:text-slate-600" href="#">Privacy</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
